var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Hello World!")]),_c('span',{staticClass:"fl-red-text"},[_vm._v("This should be red! Test: "+_vm._s(_vm.typedMethod('Hi Mom!'))+". HMR is awesome!!")])])}
var staticRenderFns = []

export { render, staticRenderFns }